import React from "react";
import { ChecksForm } from "../../components";

const CheckOut = () => {
  return <ChecksForm layout="checkout" />;
};

export default CheckOut;
